import { ActivityDisplay, Orientation, SlideDuration, Theme } from '../../shared/enums';
import { ConfigurationState } from '../../shared/interfaces';

// Per-field fallbacks, not product choices: the safest reading of a missing value, so a half-broken channel still renders.
export const CONFIG_DEFAULTS: Readonly<ConfigurationState> = {
  arePrioMessagesEnabled: true,
  channel: {
    providerUuid: '', id: 0, birthdaySlideEnabled: true, activitiesEnabled: true,
    diningEnabled: true, newsEnabled: true, activityDisplay: ActivityDisplay.Both
  },
  owner: { timezoneId: 'UTC', defaultCultureCode: 'en-US' },
  extraSlide: '', identityUuid: '', isMediaCacheEnabled: false, orientation: Orientation.Landscape,
  ownerEmail: '', priorityMessageScrollSpeed: 0, secondsPerImageInCarrousel: 5,
  slideDuration: SlideDuration.Medium, textToSpeech: false, textToSpeechSpeed: 0,
  theme: '', themeStyle: Theme.WaveDark, primaryColor: '#808080', closedCaptions: false,
  translationContext: '', serviceNames: []
};
